const findIndex = (values, limit) => {
    let number = 0;
    for (let iterator = 0; iterator < values.length; iterator++) {
        if (number < limit) {
            number += values[iterator].length;
        }
        else {
            return iterator;
        }
    }
    return -1;
};
const getCurrentDescription = (value, isLong = false, limit = 300) => {
    if (!isLong) {
        const valuesArray = value.split(" ");
        const index = findIndex(valuesArray, limit);
        if (index === -1) {
            return value;
        }
        return `${valuesArray.slice(0, index - 1).join(" ")} ...`;
    }
    return value;
};
export default getCurrentDescription;
//# sourceMappingURL=getCurrentDescription.js.map